import { pdfActions, pdfSelectors, useAppDispatch } from '@readcloud/state';
import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  prerenderAmountOptions,
  prerenderAmountOptionsLabels,
  renderModeOptions,
  renderQualityOptions,
  renderQualityOptionToEngine,
} from '../../types/BottomToolbarConstants';
import { PDFSettings } from './PDFSettings/PDFSettings';

interface IConnectedPDFSettingsProps {}

export const ConnectedPDFSettings: React.FunctionComponent<
  IConnectedPDFSettingsProps
> = (props) => {
  const pdfData = useSelector(pdfSelectors.getPDFData);

  const dispatch = useAppDispatch();
  return (
    <PDFSettings
      gutterSize={pdfData.settings.gutterSize}
      onGutterSizeChange={(gutterSize) =>
        dispatch(pdfActions.updatePDFSettings({ gutterSize }))
      }
      // continuous={pdfData.settings.continuous}
      continuous
      onContinuousChange={(continuous) => {
        dispatch(pdfActions.updatePDFSettings({ continuous }));
      }}
      flow={pdfData.settings.flow}
      onFlowChange={(flow) => {
        dispatch(pdfActions.updatePDFSettings({ flow }));
      }}
      onRenderModeChange={(renderMode) =>
        dispatch(pdfActions.updatePDFSettings({ renderMode }))
      }
      renderMode={pdfData.settings.renderMode}
      renderModeOptions={renderModeOptions}
      onEnableWalkthrough={() => {}}
      renderCache={pdfData.settings.bufferSize}
      renderCacheOptions={prerenderAmountOptions}
      renderCacheOptionsLabels={prerenderAmountOptionsLabels}
      onRenderCacheChange={(size) =>
        dispatch(
          pdfActions.updatePDFSettings({
            overscanCount: size,
            bufferSize: size,
          })
        )
      }
      renderQuality={
        pdfData.settings.renderingEngine === 'Web' ? 'High' : 'Medium'
      }
      renderQualityOptions={
        pdfData.renderServerUrl ? renderQualityOptions : undefined
      }
      onRenderQualityChange={(renderQuality) =>
        dispatch(
          pdfActions.updatePDFSettings({
            renderingEngine: renderQualityOptionToEngine[renderQuality],
          })
        )
      }
      darkMode={pdfData.settings.darkMode}
      onDarkModeChange={(darkMode) =>
        dispatch(
          pdfActions.updatePDFSettings({
            darkMode,
          })
        )
      }
    />
  );
};
